import React from 'react'
// import ToggleButton from '../../components/Kpathport/MainSection/ToggleButton';
import MainContent from '../../components/Kpathport/MainSection/MainContent';
import Precautions from '../../components/Kpathport/MainSection/Precautions';

const Kpathport = () => {

    
  return (
    <div className='bg-grayscale-gray01'>
          {/* <ToggleButton/> */}
          <MainContent/>
          <Precautions/>
    </div>
  )
}

export default Kpathport